import { observable } from "mobx";
import { inject, observer, Provider } from "mobx-react";
import React = require("react");
import { RouteComponentProps } from "react-router-dom";
import { RootStore } from "../../../core/stores/RootStore";
import { TableReservation } from "../../TableReservation/components/TableReservation";
import { TableReservationStore } from "../../TableReservation/core/stores/TableReservationStore";

interface MatchParams {
  id: string;
}

interface IProps extends RouteComponentProps<MatchParams> {
  RootStore?: RootStore;
}

interface Stores {
  TableReservationStore: TableReservationStore;
}

@inject("RootStore")
@observer
export class AdminTableReservationPage extends React.Component<IProps> {
  private stores: Stores;

  constructor(props: IProps) {
    super(props);
    console.log("this.props.match.params.id", this.props.match.params);

    this.stores = {
      TableReservationStore: new TableReservationStore(props.RootStore, true),
    };
  }

  async componentDidMount() {
    this.stores.TableReservationStore.Init();
  }

  public render() {
    return (
      <Provider {...this.stores}>
        <TableReservation />
      </Provider>
    );
  }
}
